import { FunctionComponent } from 'react'
import MealHabits from './mealHabits'
import MealAccessibilities from './mealAccessibilities'
import MealMenus from './mealMenus'
import MealTextures from './mealTextures'
import profileStyles from '../DaycareProfileHandler.module.scss'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import { useAuth } from '@/modules/context/AuthContext.tsx'
import { useTranslation } from 'react-i18next'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { Restaurant } from '@mui/icons-material'
import { useCurrentDaycareInfos } from '@/hooks/useCurrentDaycareInfos'

interface DaycareMealProps {
    hideShowMeal?: boolean
}
const DaycareMeal: FunctionComponent<DaycareMealProps> = ({ hideShowMeal }: DaycareMealProps) => {
    const { t } = useTranslation()

    const { user } = useAuth()

    const { currentDaycare: daycare } = useCurrentDaycareInfos()

    const navigate: NavigateFunction = useNavigate()

    const canUpdate: boolean = !!user?.currentDaycareRights.canWriteParamsDaycare

    return (
        <div className={profileStyles.PagePosition}>
            <MealAccessibilities daycare={daycare} canUpdate={canUpdate} />
            <MealMenus />
            <MealTextures daycare={daycare} canUpdate={canUpdate} />
            <MealHabits daycare={daycare} canUpdate={canUpdate} />
            {user?.currentDaycareRights.hasMealAccess && user.currentDaycareRights.canReadMeal && !hideShowMeal && (
                <ButtonTextIcon
                    type={'custom'}
                    customText={t('showMeal')}
                    customIcon={<Restaurant />}
                    onClick={() => navigate('/meal')}
                />
            )}
        </div>
    )
}

export default DaycareMeal
